import { Box, Pagination } from "@mui/material";

type TablePaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export const TablePagination = ({
  page,
  totalPages,
  onChange,
}: TablePaginationProps) => {
  if (totalPages <= 1) return null;

  return (
    <Box display="flex" justifyContent="center" py={2}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, p) => onChange(p)}
        color="primary"
        shape="rounded"
      />
    </Box>
  );
};
